'use client';

import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { useEstimator } from '../../context/EstimatorContext';

const SavedQuantitiesGrid = () => {
  const { formData } = useEstimator();
  const savedQuantities = formData?.quantities || [];
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <Box mt={4}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          backgroundColor: '#223A64',
          color: 'white',
          padding: '8px 16px',
          borderRadius: 1,
        }}
      >
        <Typography variant="h6">Project Metrics</Typography>
        <Button
          size="small"
          variant="outlined"
          sx={{ color: 'white', borderColor: 'white' }}
          onClick={() => setIsCollapsed((prev) => !prev)}
        >
          {isCollapsed ? 'Expand' : 'Collapse'}
        </Button>
      </Box>

      {!isCollapsed && (
        <Box
          className="ag-theme-alpine"
          sx={{
            width: '100%',
            height: 500,
            mt: 2,
          }}
        >
          <AgGridReact
            rowData={savedQuantities}
            columnDefs={[
              { headerName: 'No.', field: 'no', width: 80 },
              { headerName: 'Type', field: 'type', flex: 2 },
              {
                headerName: 'Quantity',
                field: 'quantity',
                width: 120,
                valueFormatter: ({ value }) => {
                  const selectValues = ['Natural Gas', 'NGL', 'Hydrogen'];

                  if (typeof value === 'string' && selectValues.includes(value)) {
                    return value;
                  }

                  if (value === '' || value === null || isNaN(Number(value))) {
                    return '';
                  }

                  return Number(value).toLocaleString();
                },
              },
              { headerName: 'Units', field: 'units', width: 100 },
              { headerName: 'Notes', field: 'notes', flex: 2 },
              { headerName: 'By', field: 'by', width: 100 },
              { headerName: 'Source', field: 'dataSource', flex: 1 },
            ]}
            defaultColDef={{
              resizable: true,
              editable: false,
              cellStyle: {
                backgroundColor: '#f9f9f9',
                color: '#555',
                textAlign: 'left',
              },
            }}
            domLayout="normal"
            suppressMovableColumns
          />
        </Box>
      )}
    </Box>
  );
};

export default SavedQuantitiesGrid;
